import { EntityActionNames, IEntityAction } from '../../app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { hideLaunchEditOnMobile } from '../../app/utils/MobileHelper';
import { Messages } from '../../codegen/Localize';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { ILaunchConnectedExperience } from '../../ts/ServerApi/types/actionNames';
import { ContentType,openWorkbookInDesktop } from '../actions/OpenWorkbookInDesktopAction';

export const OpenWorkbookInDesktopAction: IEntityAction<IContentInfo<ContentType.Workbook | ContentType.View>, ILaunchConnectedExperience> = {
  name: EntityActionNames.OpenWorkbookInDesktop,
  translateName: Messages.openWorkbookInDesktop,
  isVisible: (_targetItems: IContentInfo[]) => {
    return !hideLaunchEditOnMobile();
  },
  isClickable: (availableActions?: ILaunchConnectedExperience) => {
    return !!availableActions && availableActions.launchConnectedExperience;
  },
  createReduxAction: (targetItems: IContentInfo[]) => {
    return openWorkbookInDesktop(targetItems[0]);
  }
};
